export abstract class ParseAdapter {
    protected parseObject: Parse.Object;
    public get id(): string {
        return this.parseObject.id;
    }

    public get createdAt(): Date {
        return this.parseObject.createdAt;
    }

    public get updatedAt(): Date {
        return this.parseObject.updatedAt;
    }

    public get ACL(): Parse.ACL {
        return this.parseObject.getACL();
    }

    getParseInstance(): Parse.Object {
        return this.parseObject;
    }

    protected constructor(parseObject: Parse.Object) {
        this.parseObject = parseObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/abstract/ParseAdapter.ts